export default [
  function () {
    const queryParams = rawSearch => {
      const search = rawSearch[0] === '?' ? rawSearch.substring(1) : rawSearch;

      if (!search) {
        return {};
      }

      const searchObject = {};

      search.split('&').forEach(item => {
        const [key, value] = item.split('=');

        searchObject[key] = value;
      });

      return searchObject;
    };

    return {
      queryParams,
    };
  },
];
